export { default } from './AssemblyDocumentsPage';
